import { setCookieValue } from '@do/seashell';

// Utility function to validate the referral code
export const validateReferralCode = (refcode: string | null): boolean => {
  if (!refcode) return false;
  const pattern = /^[a-zA-Z0-9-_]+$/; // Allow alphanumeric characters and hyphens
  return pattern.test(refcode);
};

export const getRefcode = (search: string = window.location.search): string | null => {
  const queryParams = new URLSearchParams(search);
  const redirectURL = queryParams.get('redirect_url');
  if (redirectURL) {
    const redirectQueryParams = new URLSearchParams(redirectURL);
    const refcode = redirectQueryParams.get('refcode');
    return validateReferralCode(refcode) ? refcode : null;
  }
  return null;
};

export const getRegisterRefcode = (search: string = window.location.search): string | null => {
  const queryParams = new URLSearchParams(search);
  const refcode = queryParams.get('refcode');
  return validateReferralCode(refcode) ? refcode : null;
};

export const setRegisterCookie = (refcode: string | null): void => {
  if (refcode) {
    setCookieValue('refcode', refcode);
  }
};
